import { render, staticRenderFns } from "./DisenrollmentRisk.vue?vue&type=template&id=5b17ad09&scoped=true"
import script from "./DisenrollmentRisk.vue?vue&type=script&lang=js"
export * from "./DisenrollmentRisk.vue?vue&type=script&lang=js"
import style0 from "./DisenrollmentRisk.vue?vue&type=style&index=0&id=5b17ad09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b17ad09",
  null
  
)

export default component.exports